import { Component, OnInit, Inject, LOCALE_ID } from '@angular/core';
import { combineLatest, Observable, of } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { AuthenticationService } from '../services/authentication.service';
import { DataService } from '../services/data.service';



@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  data$: Observable<any>;

  passwordResetting: boolean = false;

  isLoggedWithouthIdSocio: boolean = false;
  authenticated$: Observable<any>;

  constructor(@Inject(LOCALE_ID) public locale: string, private authService: AuthenticationService, private dataService: DataService) { }

  ngOnInit() {

    this.authenticated$ = this.authService.isAuthenticated$.pipe(switchMap((auth) => {
      
      this.isLoggedWithouthIdSocio = false;
      if (auth) {
        return this.authService.userProfile$;
      } else {
        return of(undefined)
      }

    }), map((profile) => {
      if(profile?.idSocio) {
        this.data$ = this.dataService.getData();
        this.isLoggedWithouthIdSocio = false;
      } else if (profile) {
        this.isLoggedWithouthIdSocio = true;
      }
      
      return profile;
      
    }));


  }

  passwordReset() {
    this.passwordResetting = true;
  }

  logOut() {
    this.authService.logout();
  }

  login() {
    this.authService.login();
  }

}
